export const FETCH_HISTORY_LOADS = 'FETCH_HISTORY_LOADS'
export const CLEAR_HISTORY_LOADS = 'CLEAR_HISTORY_LOADS'
export const SAVE_FILTERS_HISTORY_LOADS = 'SAVE_FILTERS_HISTORY_LOADS'
